import type { Table } from "@tanstack/react-table";
import { Alert } from "../alert";
import { Icon } from "../icon";
import { TableBody, TableCell, TableRow } from "../table";
import { Typography } from "../typography";

type DataTableEmptyRowProps<T extends { id: unknown }> = {
  table: Table<T>;
};

export const DataTableEmptyRow = <T extends { id: unknown }>({
  table,
}: DataTableEmptyRowProps<T>) => {
  return (
    <TableBody>
      <TableRow className="hover:bg-transparent">
        <TableCell
          colSpan={table.getVisibleFlatColumns().length}
          className="text-center"
        >
          <div className="min-h-[300px] flex items-center justify-center flex-col gap-2">
            <Alert withIcon>
              <Icon icon="info" size={18} className="text-blue-500" />
            </Alert>{" "}
            <Typography
              variant="body"
              trans="no_data"
              className="text-center font-semibold"
            />
          </div>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
